export default __webpack_public_path__ + "static/1424-713d8600917fae37195c75e06b57bb93.gif";